import type {
  QueryResult,
  RangedFieldTypes,
} from '@dynatrace-sdk/client-query';

import type { VisualizationKind } from './recommenders.js';
import { VisualizationRecommenders } from './recommenders.js';

/**
 * Recommends suitable visualization types for the given records.
 * Returns array of zero or more visualizations. The result array
 * is sorted in descending order (most recommended first).
 *
 * @param records - The input records from the query
 * @param fieldTypes - Types of fields
 * @public
 */
export function recommendVisualizations(
  records: QueryResult['records'],
  fieldTypes: RangedFieldTypes[],
): VisualizationKind[] {
  return VisualizationRecommenders.map((current) => {
    const result = current.recommender(records, fieldTypes);
    return { kind: current.kind, rating: result.rating };
  })
    .filter((current) => current.rating > 0)
    .sort((first, second) => second.rating - first.rating)
    .map((current) => current.kind);
}
